import { useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from '../../Context/AuthContext';

const useOtherDocumentDeletion = () => {
  const [deleting, setDeleting] = useState(false);
  const [selectedOtherDocuments, setSelectedOtherDocuments] = useState([]);
  const { token } = useContext(AuthContext);

  const deleteOtherDocuments = async (vesselId, documentsToDelete) => {
    try {
      setDeleting(true);
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vessel/delete/otherDocuments/${vesselId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ otherDocuments: documentsToDelete }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete other documents.');
      }

      toast.success('Other documents deleted successfully.');
      setSelectedOtherDocuments([]);
      setDeleting(false);
    } catch (error) {
      toast.error(error.message || 'An error occurred while deleting other documents.');
      setDeleting(false);
    }
  };

  return { deleting, selectedOtherDocuments, setSelectedOtherDocuments, deleteOtherDocuments };
};

export default useOtherDocumentDeletion;
